import React, { Suspense, lazy } from 'react';

import './App.css';
import './styles/main.css';
import { SuspenseLoading } from 'components/suspense-loading';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import AppProvider from './hooks';
import GlobalStyle from './styles/index';
import { GlobalTokens } from './styles/tokens';

const Routes = lazy(() => import('./routes'));

const App = () => (
  <Suspense fallback={<SuspenseLoading />}>
    <AppProvider>
      <Routes />
    </AppProvider>
    <GlobalTokens />
    <GlobalStyle />
  </Suspense>
);

export { App };
